import React, { useState, useContext } from 'react';
import { useNavigate, Link, useSearchParams } from 'react-router-dom';
import axios from 'axios';
import { AuthContext, API } from '@/App';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { toast } from 'sonner';
import './Auth.css';

const Login = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);

  const { login } = useContext(AuthContext);
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const response = await axios.post(`${API}/auth/login`, {
        email,
        password
      });

      login(response.data.access_token, response.data.user);
      toast.success('Welcome back!');

      const redirect = searchParams.get('redirect');
      const text = searchParams.get('text');

      if (redirect === '/checker' && text) {
        return navigate('/checker', {
          state: { text: decodeURIComponent(text) }
        });
      }

      if (redirect) {
        return navigate(redirect);
      }

      navigate('/dashboard');

    } catch (error) {
      toast.error(error.response?.data?.detail || 'Login failed');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="auth-container">
      <div className="glass-background"></div>

      {/* ⭐ NAVBAR WITH LOGO */}
      <nav className="auth-nav fade-in">
        <div className="nav-brand" onClick={() => navigate('/')}>
          <img src="/icons/logo-512.png" alt="GrammAA Logo" className="nav-logo" />
          <span className="brand-text">GrammAA</span>
        </div>
      </nav>

      <div className="auth-box glass-panel glow-effect fade-in">
        <div className="auth-header" data-testid="login-header">
          <h1>Welcome Back</h1>
          <p>Login to continue perfecting your writing</p>
        </div>

        <form onSubmit={handleSubmit} className="auth-form">

          {/* EMAIL */}
          <div className="form-group">
            <Label htmlFor="email">Email</Label>
            <Input
              id="email"
              type="email"
              placeholder="your@email.com"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              className="glass-input"
              data-testid="login-email-input"
            />
          </div>

          {/* PASSWORD */}
          <div className="form-group">
            <Label htmlFor="password">Password</Label>
            <Input
              id="password"
              type="password"
              placeholder="••••••••"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              className="glass-input"
              data-testid="login-password-input"
            />
          </div>

          {/* FORGOT PASSWORD */}
          <div className="text-right mt-2 mb-3">
            <Link to="/forgot-password" className="auth-link text-sm">
              Forgot Password?
            </Link>
          </div>

          {/* LOGIN BUTTON */}
          <Button
            type="submit"
            disabled={loading}
            className="glass-btn auth-submit-btn"
            data-testid="login-submit-btn"
          >
            {loading ? 'Logging in...' : 'Login'}
          </Button>
        </form>

        {/* SIGNUP LINK */}
        <div className="auth-footer">
          <p>
            Don't have an account?{' '}
            <Link
              to={`/signup?redirect=${searchParams.get('redirect') || ''}&text=${searchParams.get('text') || ''}`}
              className="auth-link"
              data-testid="login-signup-link"
            >
              Sign up
            </Link>
          </p>
        </div>
      </div>
    </div>
  );
};

export default Login;
